import { render, staticRenderFns } from "./QuilityLeadMarketplaceCard.vue?vue&type=template&id=1be275a6&scoped=true&"
import script from "./QuilityLeadMarketplaceCard.vue?vue&type=script&lang=js&"
export * from "./QuilityLeadMarketplaceCard.vue?vue&type=script&lang=js&"
import style0 from "./QuilityLeadMarketplaceCard.vue?vue&type=style&index=0&id=1be275a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be275a6",
  null
  
)

export default component.exports